import LAYER_ORDER from '../constants/layerOrder';

export default function getChoroplethParentLayer({ layerName }: { layerName: string }) {
	const index = LAYER_ORDER.indexOf(layerName);
	return LAYER_ORDER[index + 1];
}
